import React, { useState, useEffect, useRef, useContext, useLayoutEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode } from "react-phone-number-input";
import TenantService from "../service/tenant";
import { StateContext } from "../utilities/context/context";
import svgComponents from "./SvgComp";
import ImagineHomeService from "./imagineHome/imagineHomeService";
import { SetUserServiceDataInLocalStorage, removeDomainName } from "../utilities/utillFunction";
import { useDispatch } from "react-redux";
import { superAdmin } from "../lib/constants";

const Login = () => {
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [errMsg, setErrMsg] = useState(null);
    const [disableBtn, setBtnDisabled] = useState(false);
    const [passwordType, setPasswordType] = useState("password");
    const [showPhoneInput, setShowPhoneInput] = useState(false);
    const [wasInitiallyAutofilled, setWasInitiallyAutofilled] = useState(false)

    const [placeHolder, setPlaceHolder] = useState({
        email: "Enter UserName or PhoneNumber",
        password: "Password",
    });
    const { countryCode, countryCodeVal, fetchUserCountryCode, setCountryCodeVal } = useContext(StateContext);
    const history = useHistory();
    const inputTypeNumber = useRef(false);

    useLayoutEffect(() => {
		const checkAutofilled = () => {
			const autofilled = !!document.getElementById('inputgroup1')?.matches('*:-webkit-autofill')
			setWasInitiallyAutofilled(autofilled)
		}
		setTimeout(checkAutofilled, 500)
	}, [])

    const dispatch = useDispatch();

    useEffect(() => {
        // if (localStorage.getItem('token')) history.push("/services");
        if (localStorage.getItem("token")) history.push("/ih-user");
        fetchUserCountryCode();
    }, []);

    const userLogin = async (e) => {
        e.preventDefault();
        let validationRes = validateInputs();
        if (typeof validationRes === "string") {
            setErrMsg(validationRes);
        } else {
            setBtnDisabled(true);
            let loginDetails = {
                username: isNumber(email) ? countryCodeVal + email.toLowerCase() : email.toLowerCase(),
                password: password,
            };
            let loginResponse = await TenantService.loginUser(loginDetails).catch((err) => {
                setBtnDisabled(false);
                setErrMsg(err.response?.data?.message ?? "Login Failed");
                return;
            });
            if (!loginResponse || !loginResponse.data || !loginResponse.data.accessToken) return;
            else {
                const payload = {
                    filter: {
                        $and: [
                            {
                                $or: [{ "user.email": loginDetails.username }, { "user.mobile": loginDetails.username }],
                            },
                            { serviceTypeName: "Imagine Home" },
                            {
                                $or: [{ "user.disabledUser": { $exists: false } }, { "user.disabledUser": false }],
                            },
                        ],
                    },
                };
                let userDetails = await ImagineHomeService.fetchUserDetailsWithToken(payload, loginResponse.data.accessToken.token);
                console.log("userDetails ", userDetails);
                if (!userDetails || !userDetails.length) {
                    // user does not exist or user has been deleted
                    setErrMsg("User Does not exist");
                    setBtnDisabled(false);
                    return;
                }
                userDetails = userDetails[0];
                if (userDetails.user.role === "ihcustomer") {
                    setErrMsg("UnAuthorized Login");
                    setBtnDisabled(false);
                    return;
                }
                if (userDetails.user?.catalogAccess !== undefined) {
                    let vendors = userDetails.user?.catalogAccess.filter((v) => v !== "");
                    console.log("vendors ", vendors);
                    localStorage.setItem("vendors", JSON.stringify(vendors));
                    dispatch({ type: "SET_USER_VENDORS", payload: vendors });
                }
                localStorage.setItem("token", loginResponse.data.accessToken.token);
                localStorage.setItem("userId", userDetails.user.userId);
                localStorage.setItem("username", userDetails.user.name);
                localStorage.setItem("exp", loginResponse.data.accessToken.exp);
                localStorage.setItem("email", userDetails.user.mobile ? userDetails.user.mobile : userDetails.user.email || "");
                localStorage.setItem("permissions", JSON.stringify(userDetails.permissions) ?? "[]");

                if (userDetails.user.email && userDetails.user.email == "support@nextqore.com") {
                    localStorage.setItem("isSupport", true);
                }
                // history.push("/services");
                await fetchImagineHomeUserData();
                // await SetUserServiceDataInLocalStorage(userDetails, dispatch)
                // history.push("/ih-user"); // call dashboard
            }
        }
    };
    const fetchImagineHomeUserData = async () => {
        Promise.all([TenantService.getPermissions(), TenantService.getMenuOptions()]).then((res) => {
            let getPermissionResponse = res[0];
            let isAdmin = false;
            let menu = res[1];
            let menumap = {};
            menu.forEach((m) => {
                if (!menumap[m.serviceId]) menumap[m.serviceId] = m;
            });
            if (getPermissionResponse && getPermissionResponse.length) {
                let filterdPermissions = [];
                getPermissionResponse.map((p) => {
                    if (p.permissions && p.permissions.length && !isAdmin) {
                        let userPersmissions = p.permissions.find((p) => {
                            return p === superAdmin;
                        });
                        if (userPersmissions) isAdmin = true;
                    }
                    if (p.serviceTypeName) {
                        if (menumap[p.serviceId]) p.menu = menumap[p.serviceId];
                        filterdPermissions.push(p);
                    }

                    // If admin, filter out "3D Model" menu
                    // if (p.serviceTypeName) {
                    //     if (menumap[p.serviceId]) {
                    //         if (isAdmin) {
                    //             for (const menu of menumap[p.serviceId].menu) {
                    //                 if (menu.items) {
                    //                     menu.items = menu.items.filter(
                    //                         (item) => item.label !== "3D Model"
                    //                     );
                    //                 }
                    //             }
                    //         }

                    //         p.menu = menumap[p.serviceId];
                    //     }
                    //     filterdPermissions.push(p);
                    // }
                    // If designer, filter out "Image Gallery" menu
                    if (p.serviceTypeName) {
                        if (menumap[p.serviceId]) {
                            if (!isAdmin) {
                                for (const menu of menumap[p.serviceId].menu) {
                                    if (menu.items) {
                                        menu.items = menu.items.filter((item) => item.label !== "Image Gallery" || item.label !=='Designer Organisations');
                                    }
                                }
                            }

                            p.menu = menumap[p.serviceId];
                        }
                        filterdPermissions.push(p);
                    }
                    return p.serviceId;
                });
                // if (isAdmin && getPermissionResponse[0].service && !getPermissionResponse[0].service.isTermsAccepted) {
                //     // setServiceIds(serviceIds);
                //     // setfilterdPermissionsData(filterdPermissions);
                //     // setShowTerms(true);
                // } else {
                //     if (filterdPermissions.length && filterdPermissions.length === 1) {
                //         // onServiceSelection(filterdPermissions[0].serviceTypeName, filterdPermissions[0], true);
                //     } else {
                //         // setServices(filterdPermissions);
                //     }
                // }
                onServiceSelection(filterdPermissions[0].serviceTypeName, filterdPermissions[0], true);
            }
        });
    };

    const onServiceSelection = async (serviceTypeName, service, singleService) => {
        let selMenu = service.menu;
        let mainMenu = [];
        if (selMenu) {
            if (Array.isArray(selMenu.menu)) {
                for (let i = 0; i < selMenu.menu.length; i++) {
                    if (selMenu.menu[i].items) {
                        selMenu.menu[i].items = selMenu.menu[i].items.filter((m) => {
                            if (m.icon) m.iconurl = process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(m.icon);
                            else m.icon = "pi pi-fw pi-circle";
                            if (m.url) {
                                m.to = removeDomainName(m.url);
                            }
                            delete m.url;
                            return m.hasOwnProperty("to");
                        });
                        mainMenu.push(selMenu.menu[i]);
                    }
                }
            } else if (selMenu.menu && selMenu.menu.items) {
                selMenu.menu.items = selMenu.menu.items.filter((m) => {
                    if (m.icon) m.iconurl = process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(m.icon);
                    else m.icon = "pi pi-fw pi-circle";
                    if (m.url) {
                        m.to = removeDomainName(m.url);
                    }
                    delete m.url;
                    return m.hasOwnProperty("to");
                });
                mainMenu.push(selMenu.menu);
            }

            await SetUserServiceDataInLocalStorage(service, dispatch);
            localStorage.setItem("menu", JSON.stringify(mainMenu));

            if (singleService) {
                if (mainMenu[0]?.url) {
                    history.push(removeDomainName(mainMenu[0].url));
                } else history.push("/");
            }
        }
    };

    const togglePassword = (e) => {
        if (passwordType === "password") {
            setPasswordType("text");
            return;
        }
        setPasswordType("password");
    };

    const onforgotPassword = () => {
        history.push("/forgot-password");
    };
    const validateInputs = () => {
        if (!email) return "Please enter email/mobile";
        if (!password) return "please enter password";
        if (isNumber(email) && !isValidPhoneNumber(countryCodeVal + email)) return "Enter valid mobile no";
        if (email && !isNumber(email)) {
            let emailRegex = /^\w+([.\-+]?\w+)*@\w+([.\-+]?\w+)*(\.\w{2,3})+$/;
            let res = emailRegex.test(email);
            if (!res) return "enter valid email";
        }
    };

    function isNumber(n) {
        if (n == "" || n == null || n == undefined) return false;
        return Number(n) == n;
    }

    const handleChange = (value) => {
        setEmail(value);
        if (!value.trim()) {
            setShowPhoneInput(false);
            inputTypeNumber.current = false;
            return;
        }
        let valIsNo = isNumber(value);
        if (valIsNo && inputTypeNumber.current === false) {
            setShowPhoneInput(true);
            inputTypeNumber.current = valIsNo;
        } else if (!valIsNo && inputTypeNumber.current === true) {
            setShowPhoneInput(false);
            inputTypeNumber.current = false;
        }
    };
    const style = {
        display: "flex", // 358px / 16 = 22.375rem
        padding: "0.75rem 1.25rem", // 12px / 16 = 0.75rem, 20px / 16 = 1.25rem
        alignItems: "center",
        width: "22.75",
        gap: "0.625rem", // 10px / 16 = 0.625rem
        borderRadius: "20px", // 12px / 16 = 0.75rem
        border: "1px solid #9AAB89",
        background: "#FFF",
    };

    const ArrowIcon = ({ type }) => {
        return (
            <div
                style={{
                    display: "inline-block",
                    cursor: "pointer",
                    transition: "color 0.3s ease-in-out",
                }}
            >
                <i
                    className={`pi pi-angle-${type}`}
                    style={{
                        fontSize: "42px",
                        color: "transparent",
                        WebkitTextStroke: "1px grey", // Outline effect
                        transition: "color 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "grey")}
                    onMouseLeave={(e) => (e.target.style.color = "transparent")}
                ></i>
            </div>
        );
    };

    // return (
    //     <div className="login-img" style={{ backgroundColor: "white", width: "100vw" }}>
    //         <div className="pages-panel flex align-items-center justify-content-center" style={{ height: "100vh" }}>
    //             <div className="w-10 sm:w-8 md:w-5 h-30rem col-12 flex flex-column flex-wrap justify-content-center align-items-center bg-white border-round-2xl shadow-2" style={{ background: "white" }}>
    //                 <img src="assets/layout/images/Charcoal.svg" style={{ height: 80, maxWidth: "100%", margin: "0", padding: "0" }} />
    //                 <form onSubmit={userLogin} autoComplete="off">
    //                     <div className="mt-5 col-12">
    //                         <div className="p-inputgroup ">
    //                             {!showPhoneInput && (
    //                                 <span className="p-inputgroup-addon" style={{ borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", border: "1px solid #9AAB89", borderRight: "0px" }}>
    //                                     <i className="pi pi-envelope"></i>
    //                                 </span>
    //                             )}
    //                             <span className="p-float-label">
    //                                 {showPhoneInput && (
    //                                     <PhoneInput
    //                                         id="userPhoneInput"
    //                                         style={{ ...style, borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", borderTopRightRadius: 0, borderBottomRightRadius: 0, maxWidth: "7em", borderRight: "0px" }}
    //                                         className="p-inputtext p-component p-filled w-full"
    //                                         value={countryCodeVal}
    //                                         onChange={setCountryCodeVal}
    //                                         international
    //                                         defaultCountry={countryCode}
    //                                     />
    //                                 )}
    //                                 <InputText
    //                                     style={{ ...style, borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: "0px" }}
    //                                     type="text"
    //                                     id="inputgroup1"
    //                                     autoFocus={true}
    //                                     onChange={(e) => handleChange(e.target.value)}
    //                                     onFocus={() => setPlaceHolder({ ...placeHolder, email: "" })}
    //                                     placeholder={placeHolder["email"]}
    //                                     className={wasInitiallyAutofilled ? 'p-filled':''}
    //                                 />
    //                                 <label>Email Or Phone Number</label>
    //                             </span>
    //                         </div>
    //                         <div className="p-inputgroup mt-4 mb-3">
    //                             <span className="p-inputgroup-addon" style={{ borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", border: "1px solid #9AAB89", borderRight: "0px" }}>
    //                                 <i className="pi pi-lock"></i>
    //                             </span>
    //                             <span className="p-float-label">
    //                                 <InputText
    //                                     autoComplete="off"
    //                                     style={{ ...style, borderLeft: "0px", borderTopLeftRadius: "0", borderBottomLeftRadius: "0", borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: "0px" }}
    //                                     type={passwordType}
    //                                     id="inputgroup2"
    //                                     className={wasInitiallyAutofilled ? 'p-filled':''}
    //                                     onChange={(e) => setPassword(e.target.value)}
    //                                     onFocus={() => setPlaceHolder({ ...placeHolder, password: "" })}
                                        
    //                                 />
    //                                 <label>Password</label>

    //                                 <div className="p-inputgroup-addon" onClick={togglePassword} style={{ borderTopRightRadius: "20px", borderBottomRightRadius: "20px", border: "1px solid #9AAB89", borderLeft: "0px" }}>
    //                                     {passwordType === "password" ? <i className="pi pi-eye-slash"></i> : <i className="pi pi-eye"></i>}
    //                                 </div>
    //                             </span>
    //                         </div>
    //                         <div>
    //                             <div
    //                                 className=" mb-2 mt-1"
    //                                 style={{
    //                                     color: "#47422F",
    //                                     textAlign: "end",
    //                                     fontFamily: "Inter, sans-serif",
    //                                     fontSize: "1rem",
    //                                     fontStyle: "normal",
    //                                     fontWeight: 400,
    //                                     cursor: "pointer",
    //                                     lineHeight: "1.25rem", // 20px / 16 = 1.25rem
    //                                 }}
    //                                 onClick={() => onforgotPassword()}
    //                             >
    //                                 Forgot Password ?
    //                             </div>
    //                         </div>
    //                         <div className="errorstyle mb-1 col-12">{errMsg}</div>
    //                         <Button style={{ borderRadius: "20px", backgroundColor: `${email && password ? "#47422F" : "#47422F"}` }} className="mb-3 px-3 py-3 w-full" label="LOGIN" disabled={disableBtn} onClick={userLogin}></Button>
    //                     </div>
    //                 </form>
    //             </div>
    //         </div>
    //     </div>
    // );

    return (
        <div className="pages-body grid login-img " style={{ backgroundColor: "white", width: "100vw" }}>
            <div className="col-12 lg:col-7 flex flex-column   bannerScreen" style={{ height: "100vh", backgroundColor: "#E5E1CF" }}>
                <div className="grid col-5 justify-content-center align-items-center mr-4 mt-0">
                    <span style={{ width: "164px", height: "170px" }}>
                        <img style={{ width: "164px", height: "170px", marginLeft: "-5.2rem", marginTop: "-2.4rem" }} src={process.env.PUBLIC_URL + "/assets/layout/images/Charcoal.svg"} alt=""></img>
                    </span>
                </div>
                <div className="flex flex-column flex wrap justify-content-center align-items-center">
                    <div
                        className="grid-nogutter justify-content-center align-items-center justify-content-center col-12"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0px", // Removes extra space between images
                        }}
                    >
                        <img src="images/banner.png" style={{ margin: "0", padding: "0", marginTop: "3rem", marginRight: "-4.5rem" }} />
                        <img src="images/banner2.png" style={{ margin: "0", padding: "0" }} />
                    </div>
                    <div className="flex flex-column align-items-center">
                        <p
                            className="mt-1"
                            style={{
                                color: "#1D1B1C",
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "20px",
                            }}
                        >
                            Design to create opportunities and empower artisans around the world.
                        </p>
                    </div>
                </div>
            </div>
            <div className="align-self-center mt-auto mb-auto col-12 lg:col-5" style={{ height: "100vh", backgroundColor: "#FBF9F3" }}>
                <div className="pages-panel  flex flex-column" style={{ height: "100vh", backgroundColor: "#FBF9F3" }}>
                    <div className="ml-0 mt-0 grid justify-content-between col-12">
                        {" "}
                        {svgComponents.svg1}
                        <div className="col-3"></div>
                        {svgComponents.svg2}
                    </div>
                    <div className="col-12 flex flex-column flex-wrap justify-content-center align-items-center ">
                        <div
                            className="  "
                            style={{
                                color: "#1D1B1C", // Since inline styles don't support CSS variables directly
                                fontFamily: "Larken",
                                fontSize: "32px",
                                fontStyle: "normal",
                                fontWeight: 100,
                                lineHeight: "normal",
                            }}
                        >
                            Login
                            <p
                                className=" lg:ml-0 ml-3 "
                                style={{
                                    color: "#1D1B1C", // Replace CSS variable with the hex value
                                    fontFamily: "Montserrat",
                                    fontSize: "16px",
                                    fontStyle: "normal",
                                    fontWeight: 300,
                                    lineHeight: "18px",
                                }}
                            >
                                Login with your registered ID to get started with us.
                            </p>
                        </div>

                        <form onSubmit={userLogin} autoComplete="off">
                            <div className="input-panel  mt-5 ml-3 col-12 ">
                                <div className="p-inputgroup ">
                                    {!showPhoneInput && (
                                        <span className="p-inputgroup-addon" style={{ borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", border: "1px solid #9AAB89", borderRight: "0px" }}>
                                            <i className="pi pi-envelope"></i>
                                        </span>
                                    )}
                                    <span className="p-float-label">
                                        {showPhoneInput && (
                                            <PhoneInput
                                                id="userPhoneInput"
                                                style={{ ...style, borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", borderTopRightRadius: 0, borderBottomRightRadius: 0, maxWidth: "7em", borderRight: "0px" }}
                                                className="p-inputtext p-component p-filled w-full"
                                                value={countryCodeVal}
                                                onChange={setCountryCodeVal}
                                                international
                                                defaultCountry={countryCode}
                                            />
                                        )}
                                        <InputText
                                            style={{ ...style, borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: "0px" }}
                                            type="text"
                                            id="inputgroup1"
                                            autoFocus={true}
                                            onChange={(e) => handleChange(e.target.value)}
                                            onFocus={() => setPlaceHolder({ ...placeHolder, email: "" })}
                                            placeholder={placeHolder["email"]}
                                            className={wasInitiallyAutofilled ? 'p-filled':''}
                                        />
                                        <label>Email Or Phone Number</label>
                                    </span>
                                </div>
                                <div className="p-inputgroup mt-4 mb-3">
                                    <span className="p-inputgroup-addon" style={{ borderTopLeftRadius: "20px", borderBottomLeftRadius: "20px", border: "1px solid #9AAB89", borderRight: "0px" }}>
                                        <i className="pi pi-lock"></i>
                                    </span>
                                    <span className="p-float-label">
                                        <InputText
                                            autoComplete="off"
                                            style={{ ...style, borderLeft: "0px", borderTopLeftRadius: "0", borderBottomLeftRadius: "0", borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: "0px" }}
                                            type={passwordType}
                                            id="inputgroup2"
                                            className={wasInitiallyAutofilled ? 'p-filled':''}
                                            onChange={(e) => setPassword(e.target.value)}
                                            onFocus={() => setPlaceHolder({ ...placeHolder, password: "" })}
                                            
                                        />
                                        <label>Password</label>

                                        <div className="p-inputgroup-addon" onClick={togglePassword} style={{ borderTopRightRadius: "20px", borderBottomRightRadius: "20px", border: "1px solid #9AAB89", borderLeft: "0px" }}>
                                            {passwordType === "password" ? <i className="pi pi-eye-slash"></i> : <i className="pi pi-eye"></i>}
                                        </div>
                                    </span>
                                </div>
                                <div>
                                    <div
                                        className=" mb-2 mt-1"
                                        style={{
                                            color: "#47422F",
                                            textAlign: "end",
                                            fontFamily: "Inter, sans-serif",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            cursor: "pointer",
                                            lineHeight: "1.25rem", // 20px / 16 = 1.25rem
                                        }}
                                        onClick={() => onforgotPassword()}
                                    >
                                        Forgot Password ?
                                    </div>
                                </div>
                                <div className="errorstyle mb-1 col-12">{errMsg}</div>
                                <Button style={{ borderRadius: "20px", backgroundColor: `${email && password ? "#47422F" : "#47422F"}` }} className="mb-3 px-3 py-3 w-full" label="LOGIN" disabled={disableBtn} onClick={userLogin}></Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
